import React from "react";
import { HashRouter, BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { pdfjs } from 'react-pdf';

// components
import Forget from "../pages/forget";
import Login from "../pages/login";
import Register from "../pages/register/Register";

// import Layout from "./Layout";
import Author269 from "../pages/login/author269";

// context
import { useUserState } from "../context/UserContext";
import CompanyRegister from "../pages/register/companyRegister";
import candidateCPV from "../pages/register/candidateCPV";

import Layouts from "../pages/share/Shortlist";
import ApproveMail from "../pages/mailApproval/ApproveMail";
import PageNotFound from "./page_not_found/PageNotFound";
import CandidateCPVconfirmation from "../pages/register/CandidateCPVconfirmation";
import DisclosureAgreement from "../pages/others/DisclosureAgreement";
import { jwtDecode } from "jwt-decode";
import AppRouter from "./Layout/routes/AppRouter";
import VendorDisclosureAgreement from "../pages/vendor/VendorDisclosureAgreement";
import SalaryBreakTemplate from "../samples/SalaryBreakTemplate";
import OfferDetailsTemplate from "../samples/OfferDetailsTemplate";
import OfferDetailsTemplateContract from "../samples/OfferDetailsTemplateContract";
import OfferDetailsChooseTemplate from "../samples/OfferDetailsChooseTemplate";
import OfferConfirmationByCandidate from "../samples/OfferConfirmationByCandidate";
import EmployeeRouter from "./Layout/routes/EmployeeRouter";
import CandidateSelfProfileAdd from "../samples/CandidateSelfProfileAdd";
import HomePage from "../pages/home/HomePage";
import { isAuthenticatedFun } from "../utils/constant";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

export default function App() {
  // global
  var { isAuthenticated } = useUserState();

  return (
    <BrowserRouter>
      <Switch>
        {/* <Route exact path="" render={() => <Redirect to="/app/dashboard" />} /> */}
        <Route exact path="/" component={HomePage} />
        <Route exact path="/app" render={() => <Redirect to="/app/dashboard" />} />
        <PrivateRoute path="/app" component={AppRouter} />


        <PublicRoute path="/emp" component={EmployeeRouter} />
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/approvalMail" component={ApproveMail} />
        <PublicRoute path="/register" component={Register} />
        <PublicRoute path="/non-disclosure-agreement" component={DisclosureAgreement} />
        <PublicRoute path="/vendor-non-disclosure-agreement" component={VendorDisclosureAgreement} />
        <PublicRoute path="/companyRegister" component={CompanyRegister} />
        <PublicRoute path="/auth/forget/:id" component={Forget} />
        <PublicRoute path="/author269" component={Author269} />
        <PublicRoute path="/candidateCPV" component={candidateCPV} />
        <PublicRoute path="/candidateConfirmationCPV" component={CandidateCPVconfirmation} />
        <PublicRoute path="/shortlist" component={Layouts} />
        <PublicRoute path="/salary-break-up-template" component={SalaryBreakTemplate} />
        <PublicRoute path="/offer-details" component={OfferDetailsTemplate} />
        <PublicRoute path="/offer-details-select-template" component={OfferDetailsChooseTemplate} />
        <PublicRoute path="/offer-details-contract" component={OfferDetailsTemplateContract} />
        <PublicRoute path="/offer-details-desicion/:candidateId/:userId" component={OfferConfirmationByCandidate} />
        <PublicRoute path="/candidate-self-profile/:candidateId/:userId" component={CandidateSelfProfileAdd} />
        <Route path="*" component={PageNotFound} />
        <Route component={Error} />
      </Switch>
    </BrowserRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {

    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticatedFun() ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }


  function PublicRoute({ component:Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated === null ? (
            <Redirect
              to={{
                pathname: "/login",
              }}
            />
          ) : (
            <Component {...props} />
            // React.createElement(component, props)
          )
        }
      />
    );
  }
}
